import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Estilos/entregaFallida.css';
import NavbarConductor from './navbar';
import Carga from '../../../components/carga';
import BotonWhatsapp from '../../../newInterface/botonWhatsapp/botonWhatsapp';
import { DatePicker } from 'antd';

const { RangePicker } = DatePicker;

/**
 * Componente funcional que gestiona la lista de pedidos con entregas fallidas para un conductor.
 * Incluye filtrado por rango de fechas, visualización de datos y navegación a detalles de un pedido.
 *
 * @function
 * @returns {JSX.Element} Vista que muestra los pedidos con entregas fallidas.
 */
function EntregaFallida() {
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    let navigate = useNavigate();

    /**
     * Hook que se ejecuta cuando el componente se monta y llama a fetchOrders
     * para recuperar la lista de pedidos con entregas fallidas.
     *
     * @returns {void}
     */
    useEffect(() => {
        fetchOrders();
    }, []);

    /**
     * Función asíncrona que obtiene los pedidos con entregas fallidas desde la API y actualiza el estado.
     * Maneja la carga inicial y muestra errores si ocurren al hacer la solicitud.
     *
     * @async
     * @function
     * @returns {Promise<void>}
     */
    const fetchOrders = async () => {
        setIsLoading(true);
        const id_usuario = localStorage.getItem('usuario_id');
        const url = `https://api.99envios.app/api/reporte-pedidos/Devuelto/${id_usuario}`;
        try {
            const response = await axios.get(url);
            setOrders(response.data);
            setFilteredOrders(response.data);  // Inicializa con todos los pedidos
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching orders:', error);
            setIsLoading(false);
        }
    };

    /**
     * Filtra los pedidos según el rango de fechas seleccionado.
     * Actualiza el estado filteredOrders con los pedidos que caen dentro del rango.
     *
     * @function
     * @param {Array} dates Array con las fechas de inicio y fin del rango.
     * @returns {void}
     */
    const handleRangeChange = (dates) => {
        if (dates) {
            const [start, end] = dates;
            const filtered = orders.filter(order => {
                const date = new Date(order.fecha_pedido.split('T')[0]);
                return date >= start && date <= end;
            });
            setFilteredOrders(filtered);
        } else {
            setFilteredOrders(orders); // Si no hay fechas seleccionadas, muestra todos los pedidos
        }
    };

    /**
     * Maneja el evento de clic para mostrar los detalles de un pedido específico.
     *
     * @function
     * @param {number} orderId ID del pedido.
     * @returns {void}
     */
    function handleDetailsClick(orderId) {
        navigate(`/conductor/pedidos/${orderId}`);
    }

    return (
        <div>
            <NavbarConductor title={"Entrega Fallida"}/>
            <div className="entregado-fail-container">
                <div className="fecha-pedidos">
                    <h2>Filtrar por rango de fechas:</h2>
                    <RangePicker
                        onChange={handleRangeChange}
                        format="YYYY-MM-DD"
                    />
                </div>
                {isLoading && <Carga />}
                {filteredOrders.map((order) => (
                    <div key={order.ID_pedido} className="pedido-fail">
                            <h4>Pedido #{order.ID_pedido}</h4>
                            <p>Cliente: {order.nombre_cliente}</p>
                            <p>Fecha pedido: {order.fecha_pedido.split('T')[0]}</p>
                        <button className="detalle-pedido-btn-fail" onClick={() => handleDetailsClick(order.ID_pedido)}>Detalles</button>
                    </div>
                ))}
            </div>
            <BotonWhatsapp />
        </div>
    );
}

export default EntregaFallida;
